<template>
    <el-card>
        <el-row>
            <div style="margin-bottom: 30px">
                <el-radio v-model="radio" label="1">{{ $t('transaction.label.time') }}</el-radio>
                <el-radio v-model="radio" label="2">{{ $t('transaction.label.orderNo') }}</el-radio>
            </div>
        </el-row>
        <!-- /* ---------------------------------- 搜索表单 1---------------------------------- */ -->
        <el-row v-if="radio === '1'">
            <el-form :model="form" :inline="true" v-bind="formProps.form" :rules="{}">
                <el-form-item prop="formTime" :label="$t('orders.label.form.submitTime')">
                    <range-date-picker :need-init="true" ref="datePick" @showDateTime="(val)=>(formTime=val)" />
                </el-form-item>
                <el-form-item prop="amount" :label="$t('transaction.label.amount')">
                    <el-input v-model="form.amount" />
                </el-form-item>
                <el-form-item :label="$t('transaction.label.channelType')" prop="channelType">
                    <el-select v-model="form.channelType">

                        <el-option v-for="item in channelTypeList" :key="item" :value="item"> </el-option>
                        <el-option :label="$t('btns.emptyValue')" value=""></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item v-if="channelCodeList" :label="$t('transaction.label.channelCode')" prop="channelCode">
                    <el-select v-model="form.channelCode">

                        <el-option v-for="item in channelCodeList" :key="item" :value="item"> </el-option>
                        <el-option :label="$t('btns.emptyValue')" value=""></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="createAcct" :label="$t('transaction.label.createAcct')">
                    <el-input v-model="form.createAcct" />
                </el-form-item>
                <el-form-item prop="createTime" :label="$t('transaction.label.createTime')">
                    <el-date-picker v-model="form.createTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" />
                </el-form-item>

                <el-form-item prop="merchantNo" :label="$t('transaction.label.merchantNo')">
                    <el-input v-model="form.merchantNo" />
                </el-form-item>
                <el-form-item prop="merchantOrderNo" :label="$t('transaction.label.merchantOrderNo')">
                    <el-input v-model="form.merchantOrderNo" />
                </el-form-item>

                <el-form-item prop="status" :label="$t('transaction.label.status')">
                    <el-select v-model="form.status">

                        <el-option v-for="item in statuslist" :key="item.label" :label="item.label"
                            :value="item.value" />
                        <el-option :label="$t('btns.emptyValue')" value=""></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button size="mini" type="success" @click="handleEmpty()">{{
                        $t('btns.empty')
                        }}</el-button>
                    <el-button size="mini" type="primary" @click="handleSearch()">{{
                        $t('btns.search')
                        }}</el-button>
                </el-form-item>
            </el-form>
        </el-row>
        <!-- /* ---------------------------------- 搜索表单 ---------------------------------- */ -->
        <el-row v-if="radio === '2'">
            <el-form :model="form1" v-bind="formProps.form1">
                <el-form-item prop="systemOrderNo" :label="$t('transaction.label.systemOrderNo')">
                    <el-input v-model="form1.systemOrderNo" />
                </el-form-item>

                <el-form-item>
                    <el-button size="mini" type="success" @click="handleEmpty()">{{
                        $t('btns.empty')
                        }}</el-button>
                    <el-button size="mini" type="primary" @click="handleSearch()">{{
                        $t('btns.search')
                        }}</el-button>
                </el-form-item>
            </el-form>
        </el-row>

        <!-- /* ---------------------------------- 表格数据 ---------------------------------- */ -->
        <el-row>
            <el-table :data="tableList" :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ textAlign: 'center' }" stripe>
                <el-table-column type="index" label="#"></el-table-column>

                <el-table-column prop="accountNumber" width="120px" :label="$t('transaction.label.accountNumber')">
                </el-table-column>
                <el-table-column prop="amount" width="120px" :label="$t('transaction.label.amount')">
                    <template slot-scope="{ row }">
                        {{ row.amount | toThousands }}
                    </template>
                </el-table-column>
                <el-table-column prop="channelCode" width="120px" :label="$t('transaction.label.channelCode')">
                </el-table-column>
                <el-table-column prop="channelType" width="120px" :label="$t('transaction.label.channelType')">
                </el-table-column>

                <el-table-column prop="id" width="220px" :label="$t('transaction.label.id')">
                </el-table-column>
                <el-table-column prop="merchantNo" width="220px" :label="$t('transaction.label.merchantNo')">
                </el-table-column>
                <el-table-column prop="merchantOrderNo" width="220px" :label="$t('transaction.label.merchantOrderNo')">
                </el-table-column>

                <el-table-column prop="remark" width="120px" :label="$t('transaction.label.remark')">
                    <template slot-scope="{ row }">
                        <el-popover width="300" placement="top-start" trigger="click" :content="row.remark">
                            <el-button slot="reference">{{ $t('btns.detail') }}</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column prop="serviceType" width="120px" :label="$t('transaction.label.serviceType')">
                </el-table-column>

                <el-table-column prop="systemOrderNo" width="220px" :label="$t('transaction.label.systemOrderNo')">
                </el-table-column>

                <el-table-column prop="updateTime" width="220px" :label="$t('transaction.label.updateTime')">
                    <template slot-scope="{ row }">
                        {{ row.updateTime | asDayjs }}
                    </template>
                </el-table-column>
            </el-table>
        </el-row>

        <!-- /* ----------------------------------- 分页 ----------------------------------- */ -->
        <v-pagination v-if="radio === '1'" v-model="pagination" :total="tableData.rows" @update="getTableData" />
    </el-card>
</template>

<script>
    import transactionApi from '@/api/transaction';
    import channelApi from '@/api/channel';
    import { debounce } from 'lodash';
    import RangeDatePicker from "../cuscom/range-date-picker.vue";
    export default {
        name: 'transaction',
        components: { RangeDatePicker },
        data() {
            return {
                formTime: [],
                form: {
                    amount: '',
                    channelCode: '',
                    channelType: '',
                    createAcct: '',
                    createTime: '',
                    merchantNo: '',
                    merchantOrderNo: '',
                    status: ''
                },
                form1: { systemOrderNo: '' },
                radio: '1',
                tableData: {},
                tableList1: [],
                channelTypeData: {},
                pagination: {
                    no: 1,
                    size: this.$defaultPaginationSize
                }
            };
        },
        computed: {
            tableList() {
                return this.radio === '1' ? this.tableData.list || [] : this.tableList1;
            },
            channelTypeList() {
                return Object.keys(this.channelTypeData) || [];
            },
            channelCodeList() {
                if (Array.isArray(this.channelTypeData[this.form.channelType])) {
                    return this.channelTypeData[this.form.channelType].length > 0
                        ? this.channelTypeData[this.form.channelType]
                        : '';
                } else {
                    return '';
                }
            }
        },
        created() {
            this.init();
        },
        mounted() {
            this.getTableData();
            this.getConfType();
        },
        methods: {
            init() {
                this.handleSearch = debounce(this._handleSearch, 200);

                this.statuslist = [
                    /* ------------------------------- @TODO 类型未完成 ------------------------------ */
                    {
                        label: this.$t('status.create'),
                        type: 'info',
                        value: 1
                    },
                    {
                        label: this.$t('status.paying'),
                        type: 'warning',
                        value: 2
                    },
                    {
                        label: this.$t('status.error'),
                        type: 'danger',
                        value: 3
                    },
                    {
                        label: this.$t('status.success'),
                        type: 'success',
                        value: 4
                    },
                    {
                        label: this.$t('status.timeout'),
                        type: '',
                        value: 5
                    }
                ];
                this.formProps = {
                    form: {
                        ref: 'form',
                        inline: true,
                        size: 'small',
                        rules: {
                            channelCode: [
                                {
                                    required: true,
                                    message: this.$t('transaction.rules.channelCode'),
                                    trigger: 'change'
                                }
                            ],
                            channelType: [
                                {
                                    required: true,
                                    message: this.$t('transaction.rules.channelType'),
                                    trigger: 'changes'
                                }
                            ]
                        }
                    },
                    form1: {
                        ref: 'form1',
                        inline: true,
                        size: 'small',
                        rules: {
                            systemOrderNo: [
                                {
                                    required: true,
                                    message: this.$t('transaction.rules.systemOrderNo'),
                                    trigger: 'blur'
                                }
                            ]
                        }
                    }
                };
            },

            /* ---------------------------------- 格式化数据 --------------------------------- */
            formatParams() {
                const [transactionBeginTime, transactionEndTime] = this.formTime;
                if (!transactionBeginTime || !transactionEndTime) {
                    // 若用户点击了时间表单的清空，则重新默认选择当天数据
                    this.$refs.datePick.handleTime('today');
                }
                return {
                    ...Object.keys(this.form).reduce((acc, key) => {
                        if (this.form[key] === 0 || this.form[key]) {
                            acc[key] = this.form[key];
                        }
                        return acc;
                    }, {}),
                    transactionBeginTime: transactionBeginTime,
                    transactionEndTime: transactionEndTime
                };
            },
            /* --------------------------------- 请求表格数据 --------------------------------- */
            async getTableData() {
                const { data } = await transactionApi.getPage({
                    data: this.formatParams(),
                    params: this.pagination
                });
                if (data && data.code === 200) {
                    this.tableData = data.data || {};
                } else {
                    this.$message.error(data.msg);
                }
            },
            async getConfType() {
                const { data } = await channelApi.confType();
                if (data && data.code == 200) {
                    this.channelTypeData = data.data;
                } else {
                    this.$message.error(data.message);
                }
            },

            /* --------------------------------- 事件驱动函数 --------------------------------- */
            handleEmpty() {
                if (this.radio === '1') {
                    this.form = {
                        amount: '',
                        channelCode: '',
                        channelType: '',
                        createAcct: '',
                        createTime: '',
                        merchantNo: '',
                        merchantOrderNo: '',
                        status: ''
                    };
                } else {
                    this.form1 = {
                        systemOrderNo: ''
                    };
                }

                try {
                    this.pagination.no = 1
                } catch (error) {
                    
                }
                
            },
            async _handleSearch() {
                if (this.radio === '1') {
                    this.$refs.form.validate((valid) => valid && this.getTableData());
                } else {
                    this.$refs.form1.validate(async (valid) => {
                        if (valid) {
                            const params = {
                                ...this.form1
                            };
                            const { data } = await transactionApi.getSearch(params);
                            if (data && data.code === 200) {
                                this.tableList1 = [data.data];
                            } else {
                                this.$message.error(data.msg);
                            }
                        }
                    });
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    >>>.el-table th {
        overflow: visible;

        .cell {
            white-space: nowrap;
            text-overflow: clip;
            overflow: visible;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/transaction/index.vue